import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ---- BuildBotics badge ----
(function addBuildBoticsBadge() {
  const removeEmergent = () => {
    const e = document.getElementById("emergent-badge");
    if (e) { e.style.display = "none"; e.remove(); }
    const e2 = document.querySelector('[id*="emergent"], [class*="emergent"]');
    if (e2) { e2.style.display = "none"; e2.remove(); }
  };
  removeEmergent();
  const observer = new MutationObserver(removeEmergent);
  observer.observe(document.body, { childList: true, subtree: true, attributes: true });

  if (document.getElementById("buildbotics-badge")) return;
  const a = document.createElement("a");
  a.id = "buildbotics-badge";
  a.href = "https://www.buildbotics.in";
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  a.innerHTML = `<span style="display:inline-flex;align-items:center;gap:8px;"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2 2 7l10 5 10-5-10-5z"></path><path d="M2 12l10 5 10-5"></path><path d="M2 17l10 5 10-5"></path></svg><span>Made by BuildBotics.in</span></span>`;
  document.body.appendChild(a);
})();
